import { Component, OnInit, Inject, TemplateRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl } from '@angular/forms';
import { ComponentType } from '@angular/cdk/portal/index';

@Component({
  selector: 'app-product-offer',
  templateUrl: './product-offer.component.html',
  styleUrls: ['./product-offer.component.scss']
})
export class ProductOfferComponent implements OnInit {

  form: FormGroup;

  constructor(
    protected dialogRef: MatDialogRef<ComponentType<any> | TemplateRef<any>>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.form = new FormGroup({
      'chkNotShowAgain': new FormControl(null)
    });
  }

  close(): void {
    this.dialogRef.close(this.form.get('chkNotShowAgain').value || false);
  }

}
